import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa para usar el Arsenal?',
  a: 'No. Cada tomo está escrito en lenguaje clínico directo y aplicado para que puedas usarlo desde el primer día, tanto si recién egresaste como si tenés años de práctica. El sistema de doble ángulo te indica exactamente qué parte es más relevante para tu nivel de experiencia.'
}, {
  q: '¿Es solo para nutricionistas de Argentina?',
  a: 'El contenido clínico es universal y aplicable en cualquier país hispanohablante. El Vademécum de Marcas, la Guía de Honorarios, las Listas de Compras y varios recursos están específicamente adaptados a Argentina con productos, contexto económico y marco legal argentino.'
}, {
  q: '¿Necesito algún software especial?',
  a: 'No. Los tomos son en PDF. El Calculador de Macros funciona en Excel o Google Sheets gratuito. Las plantillas de Canva se usan con cuenta gratuita. Todo funciona desde el primer día sin inversión adicional.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís el acceso a la descarga completa de todos los archivos. Sin esperas. Sin aprobaciones manuales.'
}, {
  q: '¿Las actualizaciones están incluidas?',
  a: 'Sí. Cada vez que actualicemos alguno de los tomos o bonos, te notificamos por email y tenés acceso a la versión actualizada sin costo adicional. Pagás una vez. Recibís todas las actualizaciones.'
}, {
  q: '¿Puedo compartirlo con colegas?',
  a: 'La licencia es de uso personal. No está permitida la redistribución ni la reventa. Cada profesional accede con su propio pago.'
}, {
  q: '¿Tiene respaldo profesional?',
  a: 'Todo el contenido clínico está basado en evidencia científica actualizada y adaptado a la práctica nutricional real. Incluye referencias a guías internacionales, criterios diagnósticos vigentes y protocolos de las principales sociedades de nutrición.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-white" data-id="element-65">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-67">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-68">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-brand-sand/30" data-id="element-69">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-brand-teal focus:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-70">
                <span className="font-bold text-brand-charcoal pr-8" data-id="element-71">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-teal flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-72" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-73">
                <p className="text-gray-600 leading-relaxed" data-id="element-74">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}